
<template>
  <div id="page-study-main" slot="no-body-bottom">
   
    <!-- <study-breadcrumb class="ml-4 mb-4 md:block hidden" v-if="breadcrumb.length" :items="breadcrumb" /> -->
    
    <div class="vx-row flex w-full no-gutter justify-center">
      <vx-card class="vx-col sm:w-full md:w-full lg:w-3/5 mb-2">
        <div class="vx-row">
          <div class="vx-col sm:w-full md:w-full lg:w-4/5 inline-flex items-center">
            <vs-breadcrumb>
                <li>{{ course }}<span class="vs-breadcrum--separator">/</span></li>
                <li>{{content.unitCode}}<span class="vs-breadcrum--separator">/</span></li>
                <li>{{content.stepName}}<span class="vs-breadcrum--separator">/</span></li>
                <li aria-current="page" class="active">{{content.menuName}}</li>
            </vs-breadcrumb>
          </div>
          <div class="vx-col sm:w-full md:w-full lg:w-1/5 text-right">
            <h5 class="text-success">{{ displayTime }}</h5>
          </div>
        </div>
        <div>
          <vs-progress :percent="progress" color="success"></vs-progress>
        </div>
      </vx-card>

      <component 
        :is="currentComponent" 
        v-bind="currentComponentProps"
        @onComplete="onComplete"
        @onNext="onNext"
        @onFinish="onFinish"
        @onStart="onStart"/>
    </div>
  </div>
</template>

<script>
import { fetchData, postData } from '@/api/module'

import StartStudy from '@/views/study-menu/StartStudy.vue'
import FinishStudy from '@/views/study-menu/FinishStudy.vue'
import NotFound from '@/views/study-menu/NotFound.vue'
import ListeningSound from '@/views/study-menu/ListeningSound.vue'
import ListeningWithPictures from '@/views/study-menu/ListeningWithPictures'
import ListeningWithSubtitles from '@/views/study-menu/ListeningWithSubtitles'
import ListeningKorean from '@/views/study-menu/ListeningKorean'
import ListeningWords  from '@/views/study-menu/ListeningWords'
// import ListeningWordsFormV08  from './ListeningWordsFormV08'
import SpeakingWords  from '@/views/study-menu/SpeakingWords'
import WordDictation1  from '@/views/study-menu/WordDictation1'
//import WordDictation2  from '@/views/study-menu/WordDictation2'
//import WordDictation3  from '@/views/study-menu/WordDictation3'
import WritingWords  from '@/views/study-menu/WritingWords'
import CheckingWords  from '@/views/study-menu/CheckingWords'
import IntonationReading from '@/views/study-menu/IntonationReading'
import SpeedReading from '@/views/study-menu/SpeedReading'
import ReadingAndTranslating from '@/views/study-menu/ReadingAndTranslating'
import ListenAndFillIn from '@/views/study-menu/ListenAndFillIn'
import SentenceDictationType1  from '@/views/study-menu/SentenceDictationType1'
import SentenceDictationType2  from '@/views/study-menu/SentenceDictationType2'
import SentenceSpeaking  from '@/views/study-menu/SentenceSpeaking'
import RolePlay from '@/views/study-menu/RolePlay'
import SpeakStraight  from '@/views/study-menu/SpeakStraight'
import PatternPractice  from '@/views/study-menu/PatternPractice'
import MatchingSentences  from '@/views/study-menu/MatchingSentences'
import WritingBlankType1 from '@/views/study-menu/WritingBlankType1'
import WritingBlankType4 from '@/views/study-menu/WritingBlankType4'
// import WritingCompositionForm  from './WritingCompositionForm'
import ReadingAndSpeaking  from '@/views/study-menu/ReadingAndSpeaking'
import ListeningPhonics1  from '@/views/study-menu/ListeningPhonics1'
import ListeningPhonics2  from '@/views/study-menu/ListeningPhonics2'
import SpeakingPhonics1 from '@/views/study-menu/SpeakingPhonics1'
import SpeakingPhonics2 from '@/views/study-menu/SpeakingPhonics2'
import MatchingPhonics1 from '@/views/study-menu/MatchingPhonics1'
import MatchingPhonics2  from '@/views/study-menu/MatchingPhonics2'
import WritingPhonics1  from '@/views/study-menu/WritingPhonics1'
// import WritingPhonics2Form  from './WritingPhonics2Form'
import PatternExtension from '@/views/study-menu/PatternExtension'
import ShadowReadings  from '@/views/study-menu/ShadowReading'

import ListeningPhonics1ForSP  from '@/views/study-menu/ListeningPhonics1ForSP'

// import SpeakingPhonicsForm  from './SpeakingPhonicsForm'
// import MatchingPhonicsForm  from './MatchingPhonicsForm'
// import WritingPhonicsForm  from './WritingPhonicsForm'
import MemorizingWords1  from '@/views/study-menu/MemorizingWords1'
import MemorizingWords2  from '@/views/study-menu/MemorizingWords2'
import GrammarExplanation  from '@/views/study-menu/GrammarExplanation'
import CheckUp from '@/views/study-menu/CheckUp'

import FinishStep  from '@/views/study-menu/FinishStep'

export default {
  components: {
    StartStudy,
    FinishStudy,
    NotFound,
    ListeningSound,
    ListeningWithPictures,
    ListeningWithSubtitles,
    ListeningKorean,
    ListeningWords,
    // ListeningWordsFormV08,
    SpeakingWords,
    WordDictation1,
    //WordDictation2,
    //WordDictation3,
    WritingWords,
    CheckingWords,
    IntonationReading,
    SpeedReading,
    ReadingAndTranslating,
    ListenAndFillIn,
    SentenceDictationType1,
    SentenceDictationType2,
    SentenceSpeaking,
    RolePlay,
    SpeakStraight,
    PatternPractice,
    MatchingSentences,
    WritingBlankType1,
    WritingBlankType4,
    //WritingBlankType2,
    // WritingCompositionForm,
    ReadingAndSpeaking,
    ListeningPhonics1,
    ListeningPhonics2,
    SpeakingPhonics1,
    SpeakingPhonics2,
    MatchingPhonics1,
    MatchingPhonics2,
    WritingPhonics1,
    // WritingPhonics2Form,
    PatternExtension,
    ShadowReadings,
    ListeningPhonics1ForSP,
    // SpeakingPhonicsForm,
    // MatchingPhonicsForm,
    // WritingPhonicsForm
    MemorizingWords1,
    MemorizingWords2,
    GrammarExplanation,
    CheckUp,
    FinishStep
  },
  data () {
    return {
      //bookCode: '',
      content: {},
      studyContents: [],
      studyResultList: [],
      currentComponent: null,
      currentComponentProps: null,
      componentMap: [],
      contentIndex: 0,
      breadcrumb: [],
      retry: 2,
      hintCount: 999,
      studentBookSeq: 0,
      studyTime: 0,
      timer: 0,
      userInfo: null
    }
  },
  props: {
    bookCode: String,
    unitCode: String,
    stepCode: String
  },
  watch: {
  },
  computed: {
    progress () {
      const progress = parseInt(this.contentIndex * 100 / (this.studyContents.length))
      return progress
    },
    displayTime () {
      const min = this.studyTime / 60
      const second =  this.studyTime % 60
      return `${this.padLeft(parseInt(min), 2)}:${this.padLeft(parseInt(second), 2)}`
    },
    course () {
      return this.bookCode.substring(0, 2)
    }
  },
  methods: {
    padLeft (nr, n, str) {
      return Array(n - String(nr).length + 1).join(str || '0') + nr
    },
    timerStart () {
      this.timer =  setInterval(function () {
        this.studyTime++
      }.bind(this), 1000)
    },
    timerStop () {
      clearInterval(this.timer)
    },
    makeBreadcrumb () {

      this.breadcrumb = [
        {
          title: this.content.unitCode 
        },
        {
          title: this.content.stepName 
        },
        {
          title: this.content.menuName 
        }
      ]
    },
    showStartComponent () {
      const firstContent = this.studyContents[0]
      this.content = {
        unitCode: firstContent.bookCode,
        stepName: firstContent.unitCode,
        menuName: '학습시작',
        menuCode: '0000'
      }
      this.makeBreadcrumb()
      this.currentComponentProps = {
        sourceContent: this.content
      }
      this.currentComponent = StartStudy
    },
    showFinishComponent () {
      const firstContent = this.studyContents[0]
      this.content = {
        unitCode: firstContent.bookCode,
        stepName: firstContent.unitCode,
        menuName: '학습완료',
        menuCode: '9999'
      }
      this.makeBreadcrumb()
      this.currentComponentProps = {
        sourceContent: this.content
      }
      this.currentComponent = FinishStudy
    },
    onStart () {
      this.timerStart()
      this.startStudy(this.contentIndex)
    },
    onComplete (ret) {
      this.updateStudyResult(ret)
      setTimeout(function () {
        this.onNext()
      }.bind(this), 2000)
    },
    onNext () {
      
      const preContentIndex = this.contentIndex

      this.contentIndex++
      if (this.contentIndex === this.studyContents.length) {
        this.timerStop()
        this.showFinishComponent()  
      } else {
        // Step이 변경되면 
        if (this.studyContents[preContentIndex].stepCode !== 
              this.studyContents[this.contentIndex].stepCode) {
          
          this.timerStop()
          this.currentComponentProps = {
            sourceContent: this.studyContents[preContentIndex]
          }
          this.currentComponent = FinishStep
        } else {
          this.startStudy(this.contentIndex)
        }
      }
    },
    // onPrevious () {
    //   if (this.contentIndex === 0) {
    //     this.timerStop()
    //     this.showStartComponent()  
    //   } else {
    //     this.contentIndex--
    //     this.startStudy(this.contentIndex)
    //   }
    // },
    onFinish () {
      
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: '알림',
        text: '학습을 종료하시겠습니까?',
        accept: this.backToMain
      })
    },
    backToMain () {
      this.$router.push(`/schedule?bookCode=${this.bookCode}`)
    },
    startStudy (index) {
      
      this.content = this.studyContents[index]
      this.makeBreadcrumb()
      
      let hint = true
      if (this.content.menuCode === 'P120') {
        hint = false  
      }
      if (this.content.menuCode === 'V031') {
        hint = false  
      }
      this.currentComponentProps = {
        sourceContent: this.content,
        retry: this.retry,
        hintCount: this.hintCount,
        defaultHint : hint
      }
      const comp = this.componentMap[this.content.menuCode]
      if (comp === undefined) {
        this.currentComponent = NotFound
      } else {
        this.currentComponent = this.componentMap[this.content.menuCode]
      }
    },
    async loadContents () {

      try { 
        const params = {
          bookCode: this.bookCode,
          unitCode: this.unitCode
        }
        const { data } = await fetchData('study-content/student', params)
        this.studyContents = data.list
        this.contentIndex = 0
        this.showStartComponent()

        // StepCode가 없다면 이전 학습에서 이어서 학습을 진행한다.
        //console.log(this.stepCode)
        if (this.stepCode === undefined) {
          this.loadStudyResultList()
        } else {
          this.setStartIndex()
        }

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    setStartIndex () {
      // 파라메터로 넘어온 StepCode의 시작 Index를 찾는다.
      let startIndex = 0
      for (let i = 0; i < this.studyContents.length; i++) {
        if (this.studyContents[i].stepCode === this.stepCode) {
          startIndex = i
          break
        }
      }
      this.contentIndex = startIndex
      //console.log(this.contentIndex)
    },
    async updateStudyResult (result) {
      //console.log(result)
      result.userID = this.userInfo.userID
      result.bookCode = this.bookCode
      try {
        await postData('/study-result', {
          userID : this.userInfo.userID,
          studyResultData : JSON.stringify(result)
        })
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }  
    },
    async loadStudyResultList () {
      try { 
        const params = {
          bookCode: this.bookCode,
          userID: this.userInfo.userID,
          unitCode: this.unitCode
        }
        const { data } = await fetchData('/study-result', params)

        // 이전 학습 기록 이후 부터 학습이 시작되게 설정한다.
        let startIndex = 0
        for (let i = 0; i < data.list.length; i++) {
          if (data.list[i].studyDate === null) {
            startIndex = i
            break
          }
        }
        this.contentIndex = startIndex
        //console.log(this.contentIndex)

      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  },
  created () {

    this.userInfo = this.$store.getters.getUserInfo

    this.componentMap['0000'] = StartStudy
    this.componentMap['9999'] = FinishStudy
    this.componentMap['L010'] = ListeningSound
    this.componentMap['L020'] = ListeningWithPictures
    this.componentMap['L030'] = ListeningWithSubtitles
    this.componentMap['L040'] = ListeningKorean
    this.componentMap['V010'] = ListeningWords
    this.componentMap['V020'] = SpeakingWords
    this.componentMap['V030'] = WordDictation1
    this.componentMap['V031'] = WordDictation1
    this.componentMap['V032'] = WordDictation1
    this.componentMap['V040'] = WritingWords
    this.componentMap['R020'] = IntonationReading
    this.componentMap['R030'] = SpeedReading
    this.componentMap['R031'] = SpeedReading
    this.componentMap['R040'] = ReadingAndTranslating
    this.componentMap['R050'] = ReadingAndSpeaking

    this.componentMap['L070'] = ListenAndFillIn
    this.componentMap['L080'] = SentenceDictationType1
    this.componentMap['L081'] = SentenceDictationType2
    this.componentMap['S010'] = SentenceSpeaking
    this.componentMap['S020'] = RolePlay
    this.componentMap['S030'] = SpeakStraight
    this.componentMap['S031'] = SpeakStraight
    this.componentMap['P050'] = ListeningPhonics1
    this.componentMap['P060'] = ListeningPhonics2
    this.componentMap['P090'] = MatchingPhonics1
    this.componentMap['P100'] = MatchingPhonics2
    this.componentMap['P110'] = WritingPhonics1
    this.componentMap['P120'] = WritingPhonics1
    this.componentMap['P070'] = SpeakingPhonics1
    this.componentMap['P080'] = SpeakingPhonics2
    this.componentMap['W020'] = WritingBlankType1
    this.componentMap['W021'] = WritingBlankType1
    this.componentMap['W022'] = WritingBlankType1
    this.componentMap['W023'] = WritingBlankType4
    this.componentMap['W010'] = MatchingSentences
    this.componentMap['R060'] = ShadowReadings
    this.componentMap['S050'] = PatternPractice
    this.componentMap['S060'] = PatternExtension
    this.componentMap['S061'] = PatternExtension
    this.componentMap['S062'] = PatternExtension
    this.componentMap['V070'] = MemorizingWords1
    this.componentMap['V071'] = MemorizingWords2
    this.componentMap['G010'] = GrammarExplanation
    this.componentMap['V050'] = CheckingWords
    this.componentMap['P010'] = ListeningPhonics1ForSP
    this.componentMap['C010'] = CheckUp
    
    this.loadContents()
  }
}

</script>
